import CheckinContainer from 'containers/customerAccounts/CheckIn/index'
import React from 'react'

const CheckinPage = () => {
  return (
    <div><CheckinContainer/></div>
  )
}

export default CheckinPage